import React, { PureComponent } from "react";
import _ from "lodash";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import {
	Button
} from "react-bootstrap";

import { DropdownButton, MenuItem } from "react-bootstrap";

import Switch from "react-switch";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import autoBind from "react-autobind";
import { Constants,Interfaces } from "@ambifi/ambifi-synthetic-voice";
import * as playerActions from "../../actions/playerActions";
import * as alertActions from "../../actions/alertActions";

import * as Utils from "../../utils/utils";
import themes from "../../constants/themes";

import NavigationPanel from "./NavigationPanel";
import Slider from "../../components/shared/Slider";
import Avatar from "../../components/userProfile/Avatar";

const SWITCH_PROPS = {
	boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.6)",
	uncheckedIcon: false,
	checkedIcon: false,
	onColor: "#43d359",
	offColor: "#e2e2e2"
};

const SLIDER_STYLE_PROPS = {
	trackStyle: {
		backgroundColor: "#0066ff"
	},
	handleStyle: {
		border: 0,
		height: 24,
		width: 24,
		marginTop: -10,
		backgroundColor: "white",
		boxShadow: "rgba(0, 0, 0, 0.5) 0px 2px 8px -2px"
	},
	valueStyle: {
		marginLeft: "30px"
	}
};

class NavigationView extends PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	handleExpandAll() {
		this.props.dispatch(
			playerActions.expandAll
		);
	}

	handleCollapseAll() {
		this.props.dispatch(
			playerActions.collapseAll
		);
	}

	handleSetStoreCloudHistory(storeCloudHistory) {
		this.props.dispatch(
			playerActions.setStoreCloudHistory,
			storeCloudHistory
		);
	}

	handleSetAudio(audio) {
		this.props.dispatch(
			playerActions.setAudio,
			audio
		);
	}

	handleSetSayCheck(sayCheck) {
		this.props.dispatch(
			playerActions.setSayCheck,
			sayCheck
		);
	}

	handleSetFocusedMode(focusedMode) {
		this.props.dispatch(
			playerActions.setFocusedMode,
			focusedMode
		);
	}

	handleSetMoveForward(moveForward) {
		this.props.dispatch(
			playerActions.setMoveForward,
			moveForward
		);
	}

	handleSetCheckbarLocation(checkbarLocation) {
		this.props.dispatch(
			playerActions.setCheckbarLocation,
			checkbarLocation
		);
	}

	handleLoadActivity(activityId) {
		this.hideNavigationView();		
		this.props.dispatch(
			playerActions.loadActivity,
			activityId
		);		
	}

	handleResetCurrentActivity() {
		let self = this;

		alertActions.showConfirm(this.props.content.alerts.resetChecklistMessage, this.props.content.alerts.resetChecklist, () => {
			self.props.dispatch(
				playerActions.clearCurrentActivityNoConfirm
			);
			self.hideNavigationView();
		});
	}

	handleResetCurrentList() {
		let self = this;

		let list = Utils.getCurrentList(this.context.tree);
		
		alertActions.showConfirm(this.props.content.alerts.resetListMessage.replace("{list.name}", list.name), this.props.content.alerts.resetList, () => {
			self.props.dispatch(
				playerActions.clearCurrentListNoConfirm
			);
			self.hideNavigationView();
		});
	} 

	handleChangeVoiceSpeed(voiceSpeed) {
		this.props.dispatch(
			playerActions.setVoiceSpeed,
			voiceSpeed
		);
	}

	handleChangeVoice(targetProp, value) {
		if (targetProp === "primary") {
			playerActions.setPrimaryVoice(value.name);
		} else {
			playerActions.setSecondaryVoice(value.name);
		}
	}

	handleResetCurrentSection() {
		let self = this;

		let section = Utils.getCurrentSection(this.context.tree);

		alertActions.showConfirm(this.props.content.alerts.resetSectionMessage.replace("{section.name}", section.name), this.props.content.alerts.resetSection, () => {
			self.props.dispatch(
				playerActions.clearCurrentSectionNoConfirm
			);
			self.hideNavigationView();
		});
	}

	hideNavigationView() {
		this.props.dispatch(playerActions.showHideNavigationView, false);
	}

	handleSetCheckbarSize(size) {
		this.props.dispatch(
			playerActions.setCheckbarSize,
			size
		);
	}

	handleSetCheckedColor(checkedColor) {
		this.props.dispatch(
			playerActions.setCheckedColor,
			checkedColor
		);
	}

	handleSetDefaultColumnWidth(defaultColumnWidth) {
		this.props.dispatch(
			playerActions.setDefaultColumnWidth,
			defaultColumnWidth
		);
	}

	handleExit() {
		this.props.dispatch(
			playerActions.saveActivityAndExit
		);
	}

	render() {

		let topContainer;
		if (this.props.user.loggedIn) {
			topContainer = <div className="navigation-drawer-top-container">
				{this.props.user.loggedIn && this.renderUserProfile()}
			</div>;
		}

		let home;
		if (!Utils.isPublished()) {
			home =  <div className="navigation-drawer-button-group-container">
				<Button bsStyle="link" className="navigation-drawer-button" onClick={this.handleExit}>
					<div className="navigation-drawer-option-content-container"><FontAwesomeIcon icon="home" /><span className="navigation-drawer-option-text">Home</span></div>
				</Button>
			</div>;
		}

		let version = process.env.REACT_APP_AMBIFI_WEB_PLAYER_VERSION;

		let navigationView = <div className="navigation-drawer-container">
			{topContainer}
			{home}
			<div className="navigation-drawer-button-group-container">
				<Button bsStyle="link" className="navigation-drawer-button" onClick={this.handleResetCurrentActivity}>
					<div className="navigation-drawer-option-content-container">
						<FontAwesomeIcon icon="eraser" /><span className="navigation-drawer-option-text">{this.props.content.menu.resetChecklist}</span>
					</div>
				</Button>
				<Button bsStyle="link" className="navigation-drawer-button">
					<div className="navigation-drawer-option-content-container" onClick={this.handleResetCurrentList}>
						<FontAwesomeIcon icon="eraser" /><span className="navigation-drawer-option-text">{this.props.content.menu.resetList}</span>
					</div>
				</Button>
				<Button bsStyle="link" className="navigation-drawer-button" onClick={this.handleResetCurrentSection}>
					<div className="navigation-drawer-option-content-container">
						<FontAwesomeIcon icon="eraser" /><span className="navigation-drawer-option-text">{this.props.content.menu.resetSection}</span>
					</div>
				</Button>
				<Button bsStyle="link" className="navigation-drawer-button" onClick={this.handleExpandAll}>
					<div className="navigation-drawer-option-content-container">
						<FontAwesomeIcon icon="expand" /><span className="navigation-drawer-option-text">{this.props.content.menu.expandAll}</span>
					</div>
				</Button>
				<Button bsStyle="link" className="navigation-drawer-button" onClick={this.handleCollapseAll}>
					<div className="navigation-drawer-option-content-container">
						<FontAwesomeIcon icon="compress" /><span className="navigation-drawer-option-text">{this.props.content.menu.collapseAll}</span>
					</div>
				</Button>
			</div>

			<div className="navigation-drawer-button-group-container">
				{/* !Utils.isPublished() && this.renderActivities() */}
				<NavigationPanel heading={this.props.content.menu.prefsTitle} body={this.renderPreferencesPanelBody()}/>
				<NavigationPanel heading={this.props.content.menu.layoutTitle} body={this.renderAppearancePanelBody()} />
				<NavigationPanel heading={this.props.content.menu.audioTitle} body={this.renderMiraPanelBody()} />			
			</div>
			<div className="ambifi-about">
				<div>{this.props.content.home.version} {version}</div>
				<div>{this.props.content.home.copyright}</div>
			</div>

		</div>;
		
		return navigationView;
	}

	renderPreferencesPanelBody() {

		let { storeCloudHistory, focusedMode, moveForward } = this.props;

		let storeCloudHistoryIcon = storeCloudHistory ? ["fas", "cloud-upload"] : "cloud-upload";
		let focsuedModeIcon = focusedMode ? ["fas", "eye"] : "eye-slash";
		let moveForwardIcon = moveForward ? ["fas", "fast-forward"] : "fast-backward";

		let body = <div>
			<div className="navigation-drawer-option-container">
				<div className="navigation-drawer-option-content-container">
					<FontAwesomeIcon icon={storeCloudHistoryIcon} /><span className="navigation-drawer-option-text">{this.props.content.menu.storeCloudHistory}</span>
				</div>
				<Switch className="switch" onChange={this.handleSetStoreCloudHistory} checked={storeCloudHistory} {...SWITCH_PROPS} />
			</div>
			<div className="navigation-drawer-option-container">
				<div className="navigation-drawer-option-content-container">
					<FontAwesomeIcon icon={focsuedModeIcon} /><span className="navigation-drawer-option-text">{this.props.content.menu.focusedMode}</span>
				</div>
				<Switch className="switch" onChange={this.handleSetFocusedMode} checked={focusedMode} {...SWITCH_PROPS}/>
			</div>
			<div className="navigation-drawer-option-container">
				<div className="navigation-drawer-option-content-container">
					<FontAwesomeIcon icon={moveForwardIcon} /><span className="navigation-drawer-option-text">{this.props.content.menu.moveForward}</span>
				</div>
				<Switch onChange={this.handleSetMoveForward} checked={moveForward} {...SWITCH_PROPS}/>
			</div>
		</div>;



		return body;
	}

	renderMiraPanelBody() {

		let { audio, sayCheck } = this.props;

		let audioIcon = audio ? ["fas", "volume-up"] : "volume-slash";
		let sayCheckIcon = sayCheck ? ["fas", "comment-check"] : "comment";

		let body = <div>
			<div className="navigation-drawer-option-container">
				<div className="navigation-drawer-option-content-container">
					<FontAwesomeIcon icon={audioIcon} /><span className="navigation-drawer-option-text">{this.props.content.menu.audio}</span>
				</div>
				<Switch className="switch" onChange={this.handleSetAudio} checked={audio} {...SWITCH_PROPS} />
			</div>
			<div className="navigation-drawer-option-container">
				<div className="navigation-drawer-option-content-container">
					<FontAwesomeIcon icon={sayCheckIcon} /><span className="navigation-drawer-option-text">{this.props.content.menu.sayCheck}</span>
				</div>
				<Switch className="switch" onChange={this.handleSetSayCheck} checked={sayCheck} {...SWITCH_PROPS} />
			</div>
			{this.renderVoiceSpeed()}
			{this.renderVoiceSelect(this.props.content.menu.primaryVoice, "primary")}
			{this.renderVoiceSelect(this.props.content.menu.secondaryVoice, "secondary")}
			{/* <div className="navigation-drawer-option-container">
				<div className="navigation-drawer-option-content-container">
					<FontAwesomeIcon icon="fast-backward" /><span className="navigation-drawer-option-text">{this.props.content.menu.moveForward}</span>
				</div>
				<Switch onChange={this.handleSetMoveForward} checked={moveForward} {...SWITCH_PROPS} />
			</div> */}
		</div>;



		return body;
	}

	renderAppearancePanelBody() {

		let body = <div>
			{this.renderCheckbarLocation()}
			{this.renderCheckbarSize()}
			{this.renderCheckedColor()}
			{this.renderDefaultColumnWidth()}
		</div>;

		return body;
	}

	renderCheckbarLocation() {

		let checkbarLocation = this.props.checkbarLocation;

		let checkbarLocationComponent = <div className="navigation-drawer-option-container">
			<div className="navigation-drawer-option-content-container">
				<FontAwesomeIcon icon="check" /><span className="navigation-drawer-option-text">{this.props.content.menu.checkbar}</span>
			</div>
			<div className="navigation-drawer-option-content-container">
				<FontAwesomeIcon icon="ban" style={{ fontSize: "24px", marginLeft: "8px", cursor: "pointer", color: (checkbarLocation === "hidden") ? "red" : "gray" }}
					onClick={() => this.handleSetCheckbarLocation("hidden")}/>
				<FontAwesomeIcon icon="chevron-circle-left" style={{ fontSize: "24px", marginLeft: "8px", cursor: "pointer", color: (checkbarLocation === "left") ? "blue" : "gray" }} 
					onClick={() => this.handleSetCheckbarLocation("left")}/>
				<FontAwesomeIcon icon="chevron-circle-down" style={{ fontSize: "24px", marginLeft: "8px", cursor: "pointer", color: (checkbarLocation === "bottom") ? "blue" : "gray" }}
					onClick={() => this.handleSetCheckbarLocation("bottom")} />
				<FontAwesomeIcon icon="chevron-circle-right" style={{ fontSize: "24px", marginLeft: "8px", cursor: "pointer", color: (checkbarLocation === "right") ? "blue" : "gray" }}
					onClick={() => this.handleSetCheckbarLocation("right")} />
			</div>
		</div>;

		return checkbarLocationComponent;
	}

	renderCheckbarSize() {

		let checkbarSizeComponent = <div className="navigation-drawer-option-container" style={{flexDirection: "column"}}>
			<div className="navigation-drawer-option-content-container" style={{paddingBottom: "8px"}}>
				<FontAwesomeIcon icon="th-large" /><span className="navigation-drawer-option-text">{this.props.content.menu.checkbarSize}</span>
			</div>
			<div style={{ marginLeft: "20px" }}><Slider min={40} max={100} step={2} {...SLIDER_STYLE_PROPS} onChange={this.handleSetCheckbarSize} value={this.props.checkbarSize}/></div>
		</div>;
		
		return checkbarSizeComponent;
	}

	renderCheckedColor() {

		let checkedColor = this.props.checkedColor;

		let checkedColorComponent = <div className="navigation-drawer-option-container">
			<div className="navigation-drawer-option-content-container" style={{ color: checkedColor }}>
				<FontAwesomeIcon icon="check" /><span className="navigation-drawer-option-text" style={{ color: checkedColor }}>{this.props.content.menu.checkedColor}</span>
			</div>
			<div className="navigation-drawer-option-content-container">
				<FontAwesomeIcon icon="check-circle" style={{ fontSize: (checkedColor === "black") ? "32px": "24px", marginLeft: "8px", cursor: "pointer", color: "black" }}
					onClick={() => this.handleSetCheckedColor("black")} />
				<FontAwesomeIcon icon="check-circle" style={{ fontSize: (checkedColor === "green") ? "32px": "24px", marginLeft: "8px", cursor: "pointer", color: "green" }}
					onClick={() => this.handleSetCheckedColor("green")} />
				<FontAwesomeIcon icon="check-circle" style={{ fontSize: (checkedColor === "blue") ? "32px": "24px", marginLeft: "8px", cursor: "pointer", color: "blue"}}
					onClick={() => this.handleSetCheckedColor("blue")} />
			</div>
		</div>;

		return checkedColorComponent;
	}

	renderVoiceSelect(label, targetProp) {
		const { voices, [`${targetProp}Voice`]:currentVoice } = this.props;
		
		let _currentVoice = currentVoice;
		console.log(targetProp, _currentVoice);
		if (!_currentVoice) {
			voices.forEach(voice => {
				if (voice.def) {
					_currentVoice = voice.name;
				}
			});
		}

		let defaultColumnWidthComponent = <div className="navigation-drawer-option-container" style={{ flexDirection: "column" }}>
			<div className="navigation-drawer-option-content-container" style={{ paddingBottom: "8px" }}>
				<span className="navigation-drawer-option-text" style={{ fontWeight: "bold", fontColor:"#778899"}}>{label}</span>
			</div>
			<div style={{ marginLeft: "20px" }}>
				<DropdownButton
					title={`${_currentVoice ? _currentVoice:"Select a voice"}`}
					key={"dropdown-voice"}
					id="drodpown-voice"
				>
					{
						voices.map((voice, i) => {
							return <MenuItem active={voice.name === _currentVoice} key={`voice-${voice.name}`} eventKey={i} onClick={() => { this.handleChangeVoice(targetProp, voice); }}>{voice.name} ({voice.lang})</MenuItem>;
						})
					}
				</DropdownButton>

				{/* <Slider min={800} max={1600} step={2} {...SLIDER_STYLE_PROPS} onChange={this.handleSetDefaultColumnWidth} value={this.props.defaultColumnWidth} /> */}


			</div>
		</div>;

		return defaultColumnWidthComponent;

	}

	renderVoiceSpeed() {
		const defaultSpeed = Constants.VOICE_SPEED_NORMAL;
		const { voiceSpeed } = this.props;
		let currentVoiceSpeed = defaultSpeed;
		const { SyntheticVoiceProvider } = Interfaces;
		if (voiceSpeed && !_.isEmpty(voiceSpeed)) {
			currentVoiceSpeed = SyntheticVoiceProvider.getSpeedConstantFromValue(voiceSpeed);
		}

		let defaultColumnWidthComponent = <div className="navigation-drawer-option-container" style={{ flexDirection: "column" }}>
			<div className="navigation-drawer-option-content-container" style={{ paddingBottom: "8px" }}>
				<FontAwesomeIcon icon="hourglass-half" /><span className="navigation-drawer-option-text">{this.props.content.menu.voiceSpeed}</span>
			</div>
			<div style={{ marginLeft: "20px" }}>
				<DropdownButton
					title={`Current speed: ${currentVoiceSpeed}`}
					key={"dropdown-speed"}
					id="dropdown-voice-audio-speed"
				>
					{
						Constants.VOICE_SPEEDS.map((voiceSpeed,i) => {
							return <MenuItem active={voiceSpeed === currentVoiceSpeed} key={`voice-speed-${voiceSpeed}`} eventKey={i} onClick={() => { this.handleChangeVoiceSpeed(voiceSpeed); }}>{voiceSpeed}</MenuItem>;
						})
					}
				</DropdownButton>
				
				{/* <Slider min={800} max={1600} step={2} {...SLIDER_STYLE_PROPS} onChange={this.handleSetDefaultColumnWidth} value={this.props.defaultColumnWidth} /> */}
			
			
			</div>
		</div>;

		return defaultColumnWidthComponent;

	}

	renderDefaultColumnWidth() {

		let defaultColumnWidthComponent = <div className="navigation-drawer-option-container" style={{ flexDirection: "column" }}>
			<div className="navigation-drawer-option-content-container" style={{ paddingBottom: "8px" }}>
				<FontAwesomeIcon icon="arrows-h" /><span className="navigation-drawer-option-text">{this.props.content.menu.maxColumnWidth}</span>
			</div>
			<div style={{ marginLeft: "20px" }}><Slider min={800} max={1600} step={2} {...SLIDER_STYLE_PROPS} onChange={this.handleSetDefaultColumnWidth} value={this.props.defaultColumnWidth}/></div>
		</div>;

		return defaultColumnWidthComponent;

	}

	renderActivities() {
		let self = this;
		let { activities } = this.props;
		let component;

		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;

		if (activities.length > 1) {
			
			let body;
	
			let activityButtons = activities.map(activity => {
				let color = (this.props.activity.id === activity.id) ? theme.nav.item.selectedColor : theme.nav.item.color; 
				return <Button bsStyle="link" className="navigation-drawer-button" onClick={() => self.handleLoadActivity(activity.id)}>
					<div className="navigation-drawer-option-content-container">
						<FontAwesomeIcon style={{ color: color }} icon={Utils.getIconForGenre(activity.genre, self.props.genres)} /><span style={{ color: color }} className="navigation-drawer-option-text">{activity.name}</span>
					</div>
				</Button>;

			});

			body = <div style={{display: "flex", flexDirection: "column"}}>{activityButtons}</div>;

			component = <NavigationPanel bodyStyle={{ paddingLeft: "0px", paddingRight: "0px" }} heading="Activities" body={body} />;
		}


		return component;
	}

	renderUserProfile() {
		let component = <div>
			<Avatar name={this.props.user.name} size={50}/>
			<div className="profile-display-name" style={{ color: themes.default.nav.profile.color}}>{this.props.user.name}</div>
		</div>;
			
		return component;		
	}
}
	
NavigationView.contextTypes = {
	tree: PropTypes.baobab
};
/**
 * 	sayCheck: true,
	checkLabel: true,
	audio: true,
	challengeResponseMode:false,
	voices: {
		list: [
		]
	},
 */
export default branch({
	checkbarSize: ["appPreferences", "checkbarSize"],
	checkbarLocation: ["appPreferences", "checkbarLocation"],
	checkedColor: ["appPreferences", "checkedColor"],
	defaultColumnWidth: ["appPreferences", "defaultColumnWidth"],
	storeCloudHistory: ["storeCloudHistory"],
	focusedMode: ["focusedMode"],
	moveForward: ["moveForward"],
	activities: ["activities"],
	activity: ["activity"],
	genres: ["genres"],
	activityTheme: ["activity", "theme"],
	user: ["user"],
	audio: ["appPreferences", "voice", "audio"],
	sayCheck: ["appPreferences", "voice","sayCheck"],
	voiceSpeed: ["appPreferences", "voice", "speed"],
	voices: ["appPreferences", "voice", "voices", "list"],
	primaryVoice: ["appPreferences", "voice", "voices", "primary"],
	secondaryVoice: ["appPreferences", "voice", "voices", "secondary"],
	content: ["content"]
}, NavigationView);